import React, { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { faqs } from '../data/content';

const FAQ = () => {
  return (
    <div className="min-h-screen bg-white pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-6" style={{ color: '#5E7F8A' }}>
            Frequently Asked Questions
          </h1>
          <p className="text-xl mb-8" style={{ color: '#5E7F8A' }}>
            Find answers to common questions about our mediation services.
          </p>
          <div className="w-24 h-1 mx-auto" style={{ backgroundColor: '#9BB2A2' }}></div>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border rounded-lg px-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <AccordionTrigger 
                className="text-left text-lg font-semibold py-6 hover:no-underline"
                style={{ color: '#5E7F8A' }}
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed pb-6" style={{ color: '#5E7F8A' }}>
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Still Have Questions CTA */}
        <div className="mt-16 text-center bg-gray-50 rounded-lg p-10">
          <h2 className="text-2xl font-bold mb-4" style={{ color: '#5E7F8A' }}>
            Still Have Questions?
          </h2>
          <p className="text-lg mb-6" style={{ color: '#5E7F8A' }}>
            Schedule a free consultation to discuss your specific situation.
          </p>
          <a 
            href="/contact"
            className="inline-block px-8 py-4 rounded-md text-white font-semibold transition-all hover:shadow-lg"
            style={{ backgroundColor: '#9BB2A2' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#8FA596'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#9BB2A2'}
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
